import { __awaiter, __generator } from "tslib";
import { LocalStorageCapsule } from 'data-capsule';
var capsule;
var LOCAL_STORAGE_MESSAGE_KEY = 'page_message';
var resolveKey = function (key) { return __awaiter(void 0, void 0, void 0, function () {
    var originalValue, storageKeys, updatedStorageKeys, newKeys;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, LocalStorage.getItem(key)];
            case 1:
                originalValue = _b.sent();
                return [4 /*yield*/, capsule.removeItem(key)];
            case 2:
                _b.sent();
                storageKeys = Object.keys(localStorage);
                return [4 /*yield*/, LocalStorage.setItem(key, originalValue)];
            case 3:
                _b.sent();
                updatedStorageKeys = Object.keys(localStorage);
                newKeys = updatedStorageKeys.filter(function (storageKey) { return !storageKeys.includes(storageKey); });
                return [2 /*return*/, (_a = newKeys[0]) !== null && _a !== void 0 ? _a : null];
        }
    });
}); };
export var LocalStorage = {
    setItem: function (key, value) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, init() && capsule.setItem(key, JSON.stringify(value), { category: 'functional' })];
    }); }); },
    getItem: function (key) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!init()) return [3 /*break*/, 4];
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    _b = (_a = JSON).parse;
                    return [4 /*yield*/, capsule.getItem(key)];
                case 2: return [2 /*return*/, _b.apply(_a, [_d.sent()])];
                case 3:
                    _c = _d.sent();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, null];
            }
        });
    }); },
    monitorItem: function (key, cb) { return __awaiter(void 0, void 0, void 0, function () {
        var resolvedKey, handler;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!init()) {
                        return [2 /*return*/, null];
                    }
                    return [4 /*yield*/, resolveKey(key)
                        // @ts-expect-error
                    ];
                case 1:
                    resolvedKey = _a.sent();
                    handler = function (_a) {
                        var testKey = _a.key, newValue = _a.newValue;
                        return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_b) {
                                if (testKey === resolvedKey) {
                                    try {
                                        cb(JSON.parse(JSON.parse(newValue).value));
                                    }
                                    catch (e) {
                                        console.error(e);
                                    }
                                }
                                return [2 /*return*/];
                            });
                        });
                    };
                    window.addEventListener('storage', handler);
                    return [2 /*return*/, function () {
                            window.removeEventListener('storage', handler);
                        }];
            }
        });
    }); },
    sendMessage: function (type, payload) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, LocalStorage.setItem(LOCAL_STORAGE_MESSAGE_KEY, { type: type, payload: payload, time: Date.now() })];
    }); }); },
    monitorMessage: function (type, cb) { return __awaiter(void 0, void 0, void 0, function () {
        var value;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, LocalStorage.getItem(LOCAL_STORAGE_MESSAGE_KEY)];
                case 1:
                    value = _a.sent();
                    if ((value === null || value === void 0 ? void 0 : value.type) === type && (Date.now() - value.time) / 1000 < 10) {
                        cb(value.payload);
                    }
                    return [2 /*return*/, LocalStorage.monitorItem(LOCAL_STORAGE_MESSAGE_KEY, function (newValue) {
                            if (newValue) {
                                var actualType = newValue.type, payload = newValue.payload;
                                if (actualType === type) {
                                    cb(payload);
                                }
                            }
                        })];
            }
        });
    }); },
    removeItem: function (key) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, init() && capsule.removeItem(key)];
    }); }); },
};
var init = function () {
    try {
        if (!capsule) {
            var key = 'random-key6';
            window.localStorage.setItem(key, key);
            window.localStorage.removeItem(key);
            capsule = LocalStorageCapsule({ namespace: 'wix-events' });
        }
        return true;
    }
    catch (e) {
        return false;
    }
};
//# sourceMappingURL=local-storage.js.map